// Mixtures Mutations

export const setFullMixturesList = (state, payload) => {
  state.fullMixturesList = payload
}

export const updateMixturesList = (state, payload) => {
  state.mixturesList = payload
}

export const setMixtureInfo = (state, payload) => {
  state.mixtureInfo = payload
}
